export const selectIsDestructiveActionPending = state =>
  state.destructiveModal?.isDestructiveActionPending ?? false;

export const selectPendingDestructiveNavigation = state =>
  state.destructiveModal?.pendingNavigation ?? null;

export const selectPendingDestructiveNavigationTriggerOrigin = state =>
  state.destructiveModal?.pendingNavigationTriggerOrigin ?? null;
